module.exports = __webpack_public_path__ + "img/108.3ffee464.jpg";